export const SET_IS_LOADING_LEAD_DISPOSITION = 'SET_IS_LOADING_LEAD_DISPOSITION';
export const SET_IS_SUCCESS_LEAD_DISPOSITION = 'SET_IS_SUCCESS_LEAD_DISPOSITION';
export const SET_IS_ERROR_LEAD_DISPOSITION = 'SET_IS_ERROR_LEAD_DISPOSITION';
export const GET_LEAD_DISPOSITION = 'GET_LEAD_DISPOSITION';



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/constants/get_lead_disposition.constants.js